import { useEventContext } from '../../contexts/EventContext';
import { useEventDetails } from '../../../hooks/useEventDetails';
import { DetailsPage } from './DetailsPage';
import { DetailsPageV1 } from '../../v1/components/details/DetailsPageV1';

/**
 * DetailsPageWrapper - ROUTING ONLY
 *
 * This component's ONLY responsibility is to determine
 * whether to render the V1 or V2 details page.
 *
 * DO NOT add any other logic to this component.
 * DO NOT pass props between components.
 * DO NOT add conditional features.
 *
 * This is purely a routing decision based on isV1Event flag.
 */
export const DetailsPageWrapper = () => {
  const { eventSlug } = useEventContext();
  const { data: eventDetails } = useEventDetails(eventSlug);

  // ONLY routing decision

  console.log('DetailsPageWrapper - Event Details:', eventDetails);
  if (eventDetails?.isV1Event) {
    return <DetailsPageV1 />;
  }

  return <DetailsPage />;
};